import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CreateAsyncTranslateTaskService } from '../create-async-translate-task-service';
import type { TranslateOptions } from '../../types';
import { CreateSyncTranslateTaskService } from '../create-sync-translate-task-service';
import { CreateAsyncTranslateTaskApi } from '@/infrastructure/api-functions/core-drafting-api/create-async-translate-task-api';

@injectable()
export class CreateAsyncTranslateTaskServiceImpl implements CreateAsyncTranslateTaskService {
    constructor(
        @inject(CreateSyncTranslateTaskService)
        private readonly _createSyncTranslateTaskService: CreateSyncTranslateTaskService,
        @inject(CreateAsyncTranslateTaskApi)
        private readonly _createAsyncTranslateTaskApi: CreateAsyncTranslateTaskApi,
    ) {}

    async createAsyncTranslateTask(taskId: string, translateOptions: TranslateOptions): Promise<void> {
        console.info('创建异步翻译任务', taskId, translateOptions);
        await this._createSyncTranslateTaskService.createTranslateTask(taskId, translateOptions);
        this._createAsyncTranslateTaskRepository(taskId);
    }

    private _createAsyncTranslateTaskRepository(taskId: string): Promise<boolean> {
        return this._createAsyncTranslateTaskApi.createAsyncTranslateTask({
            task_id: taskId,
        });
    }
}
